import {createAction, handleActions} from 'redux-actions';
import axios from 'axios/index';
import * as _ from 'lodash';
import {setStockLoading} from './LoadingReducer';

const parseStockData = (response) => {
  return _.map(response.data, (item, index) => {
    const fields = [
      'id',
      'name',
      'qty',
      'unit',
      'type',
      'price',
      'code'];
    let data = {};
    _.each(fields, (name, i) => data[name] = item[i]);
    return data;
  });
};

export const setStockList = createAction('SET_STOCK_LIST');
export const loadStockList = (action = {}) => (dispatch, getState) => {
  const {query, category} = action;

  dispatch(setStockLoading({loading: true}));
  axios.get(
      `/report/stock/genpart?format=json&length=50&q=${query}&cat=${category}`).
      then((response) => {
        const data = parseStockData(response.data);
        dispatch(setStockList({
          data: data,
          payload: action,
        }));
        dispatch(setStockLoading({loading: false}));
      }).
      catch((error) => {
        console.error(error);
      });
};

export const StockReducer = (defaultState) => handleActions({
  loadStockList,
  [setStockList](state, action = {}) {
    const {data, payload} = action.payload || {};
    return data || [];
  },
}, defaultState);

export default StockReducer;


// WEBPACK FOOTER //
// ./src/stores/CarDamage/StockReducer.js